import Modal from 'components/layout/Modal/container';

export default Modal;
